import { render, staticRenderFns } from "./PlacementSidebar.vue?vue&type=template&id=c8a566a8"
import script from "./PlacementSidebar.vue?vue&type=script&lang=js"
export * from "./PlacementSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports